"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGender = exports.SurveyType = void 0;
var SurveyType;
(function (SurveyType) {
    SurveyType["Choice"] = "choice";
    SurveyType["Scale"] = "scale";
    SurveyType["Text"] = "text";
})(SurveyType = exports.SurveyType || (exports.SurveyType = {}));
var UserGender;
(function (UserGender) {
    UserGender["Female"] = "female";
    UserGender["Male"] = "male";
    UserGender["Other"] = "other";
})(UserGender = exports.UserGender || (exports.UserGender = {}));
//# sourceMappingURL=mobileApi.js.map